export default "__VITE_ASSET__450aa1b8__"